import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Props {
  open: boolean;
  onClose: () => void;
  surveys: Array<{ id: number; name: string }>;
}

const SurveySelectModal: React.FC<Props> = ({
  open,
  onClose,
  surveys,
}) => {
  const navigate = useNavigate();
  const [selectedSurvey, setSelectedSurvey] = useState<number | "">("");

  const handleNext = () => {
    if (!selectedSurvey) return;

    navigate(`/surveys/questions/${selectedSurvey}`);
    onClose();
  };  

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Select Survey</DialogTitle>

      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Survey</InputLabel>

          <Select
            value={selectedSurvey}
            label="Survey"
            onChange={(e) => setSelectedSurvey(e.target.value as number)}
          >
            {surveys?.map((survey) => (
              <MenuItem key={survey.id} value={survey.id}>
                {survey.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>

        <Button
          variant="contained"
          onClick={handleNext}
          disabled={!selectedSurvey}
        >
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SurveySelectModal;